import type { PlanosAtivacao } from '../../services/analytics';
import { DASH, formatDays, formatInt, formatPct } from './format';
import type { MetricInfoKey } from './metricInfo';
import { shareCaption } from './overviewCards';

export type ActivationCardId = Extract<
    MetricInfoKey,
    'gratuitasTrial' | 'planosMensais' | 'planosAnuais' | 'tempoMedioPrimeiroLancamento' | 'ativacaoD7' | 'ttvMediano'
>;

export interface ActivationCardView {
    id: ActivationCardId;
    title: string;
    value: string;
    caption: string;
}

/** "20 de 24 contas elegíveis". Sem base, nao ha grupo elegivel e o card mostra traco. */
export function eligibleCaption(count: number, base: number): string {
    if (base <= 0) return 'Sem contas elegíveis';
    return `${formatInt(count)} de ${formatInt(base)} ${base === 1 ? 'conta elegível' : 'contas elegíveis'}`;
}

/** Cards da secao Planos e ativação, na ordem e com os textos do prototipo. */
export function buildActivationCards(p: PlanosAtivacao): ActivationCardView[] {
    return [
        {
            id: 'gratuitasTrial',
            title: 'Gratuitas',
            value: formatInt(p.gratuitasTrial.count),
            caption: shareCaption(p.gratuitasTrial.pct),
        },
        {
            id: 'planosMensais',
            title: 'Planos mensais',
            value: formatInt(p.mensais.count),
            caption: shareCaption(p.mensais.pct),
        },
        {
            id: 'planosAnuais',
            title: 'Planos anuais',
            value: formatInt(p.anuais.count),
            caption: shareCaption(p.anuais.pct),
        },
        {
            id: 'tempoMedioPrimeiroLancamento',
            title: 'Tempo médio ao 1º lançamento',
            value: formatDays(p.tempoMedioPrimeiroLancamentoDias),
            caption: '',
        },
        {
            id: 'ativacaoD7',
            title: 'Ativação D7',
            value: p.ativacaoD7.pct === null ? DASH : formatPct(p.ativacaoD7.pct),
            caption: eligibleCaption(p.ativacaoD7.count, p.ativacaoD7.base),
        },
        {
            id: 'ttvMediano',
            title: 'TTV mediano',
            value: formatDays(p.ttvMedianoDias),
            caption: '',
        },
    ];
}
